import React from "react";
import { Box } from "@UI/Components/Box/Box";
import { CategoriesRecommendationCarousel } from "./CategoriesRecommendationCarousel";
import { SPRecommendationCarousel } from "./SPRecommendationCarousel";
import { ThemeProvider } from "@UI/Contexts/ThemeProvider";
import { CSSIsolation } from "@UI/Contexts/CSSIsolation";
import useMediaQuery from "@UI/hooks/useMediaQuery";

export const Recommendations = () => {
  const { isMobile } = useMediaQuery();

  return (
    <CSSIsolation>
      <ThemeProvider>
        <Box
          display="flex"
          flexDirection="column"
          gap={6}
          width={isMobile ? "100vw" : "100%"}
          overflow="hidden"
          paddingX={2}
          marginX={-2}
          marginBottom={8}
        >
          <CategoriesRecommendationCarousel />
          <SPRecommendationCarousel />
        </Box>
      </ThemeProvider>
    </CSSIsolation>
  );
};
